// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const OptimizationIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Optimization/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M22 15c0 3.87-3.13 7-7 7l1.05-1.75M2 9c0-3.87 3.13-7 7-7L7.95 3.75"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M10 18c0 .75-.21 1.46-.58 2.06A3.97 3.97 0 0 1 6 22a3.97 3.97 0 0 1-3.42-1.94A3.92 3.92 0 0 1 2 18c0-2.21 1.79-4 4-4s4 1.79 4 4Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m4.441 18 .99.99 2.13-1.97"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M22 6c0 .75-.21 1.46-.58 2.06-.21.36-.48.68-.79.94-.7.63-1.62 1-2.63 1a3.97 3.97 0 0 1-3.42-1.94A3.92 3.92 0 0 1 14 6c0-1.26.58-2.39 1.5-3.12A3.999 3.999 0 0 1 22 6ZM19.07 7.04l-2.12-2.11M19.05 4.96l-2.12 2.11"
}));
export default OptimizationIcon;